export const ProposalAbstractState = {
	url: '/proposal',
	abstract: true,
	redirectTo: 'proposal.customer', // default child
	template:
		'<builder-abstract-page provider-flags="$resolve.providerFlags" class="abstract"></builder-abstract-page>',
	lazyLoad: $transition$ => {
		const $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
		const $log = $transition$.injector().get('$log');
		return import(
			/* webpackChunkName: "proposalAbstractMod" */
			'@Containers/builder-abstract-page/builder-abstract-page.cmp.js'
		)
			.then(res => $ocLazyLoad.load({name: res.default}))
			.catch(err => $log.error(err));
	},
	resolve: {
		/** @ngInject */
		providerFlags: (RoutesResolveSvc, $state) =>
			RoutesResolveSvc.getFlagsPrivate({fromState: 'proposal'})
				.then(data => data)
				.catch(() => $state.go('user.auth')),
	},
};
